export default  (response = {}) => {
    let { autoSuggestions = [] } = response || {};
    autoSuggestions = response.map(item => {return {label: item.suggestionText, type: item.type, displayType: item.displayType};});
    return ({autoSuggestions, ...response});
};
